// Toma un rut y lo separa en número y dígito verificador.
export function parseRut(rut: string): any {
	let primeraParte = rut.split("-")[0] || "";
	let segundaParte = rut.split("-")[1] || "";
	primeraParte = primeraParte.replace(/\./g, "").replace(/,/g, "");

	return {
		rut: primeraParte,
		dv: segundaParte.toUpperCase(),
	};
}

// Valida si un RUT es válido.
export function validarRutMod11(rutCompleto: string): boolean {
	const { rut, dv } = parseRut(rutCompleto);
	if (!rut || dv == null) return false;

	const cuerpo = rut.toString();
	let suma = 0;
	let multiplicador = 2;

	// Recorremos de derecha a izquierda
	for (let i = cuerpo.length - 1; i >= 0; i--) {
		suma += parseInt(cuerpo.charAt(i), 10) * multiplicador;
		multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
	}

	const resto = suma % 11;
	const verificadorCalculado = 11 - resto;

	let dvEsperado: string;
	if (verificadorCalculado === 11) {
		dvEsperado = "0";
	} else if (verificadorCalculado === 10) {
		dvEsperado = "K";
	} else {
		dvEsperado = verificadorCalculado.toString();
	}

	return (
		dv.toUpperCase() === dvEsperado &&
        rut <= 50000000 &&
		/^(?:\d{1,2}\.?\d{3}\.?\d{3}|\d{1,3}\.?\d{3})-[\dkK]$/.test(rutCompleto)
	);
}

function limpiarRut(rut: string) {
	return rut.replace(/[^0-9kK]/g, "").toUpperCase();
}

export function rutSinDV(rutCompleto: string) {
	const rutLimpio = limpiarRut(rutCompleto);
	return Number(rutLimpio.slice(0, -1));
}

export function soloDV(rutCompleto: string) {
	const rutLimpio = limpiarRut(rutCompleto);
	return rutLimpio.slice(-1);
}

export function formatearRutCompleto(rutCompleto: string) {
	const rut = rutSinDV(rutCompleto).toString();
	const dv = soloDV(rutCompleto);

	var rutFormateado = "";
	var i = rut.length;

	while (i > 3) {
		rutFormateado = `.${rut.slice(i - 3, i)}${rutFormateado}`;
		i -= 3;
	}

	return `${rut.slice(0, i)}${rutFormateado}-${dv}`;
}
